<template>
  <sui-table basic="very" celled>
    <sui-table-body>
      <sui-table-row>
        <sui-table-cell valign="top">
          <h3 is="sui-header">Billing Address</h3>
          <div class="address">
            <span>{{data.FullName}}</span>
            <span>{{data.AddressLine1}}</span>
            <span>{{data.AddressLine2}}</span>
            <span>{{data.City}}</span>
            <span>{{data.PostCode}}</span>
          </div>
        </sui-table-cell>
        <sui-table-cell valign="top">
          <h3 is="sui-header">Payment Details</h3>
          <p v-if="data && data.CardLast4">
            Card: xxxx xxxx xxxx {{data.CardLast4}} expiring {{data.CardExpiry}}
          </p>
          <sui-button basic compact color="pink" icon="credit card outline" @click="$emit('change')">{{data.CardLast4 ? 'Change' : 'Set'}} payment details</sui-button>
        </sui-table-cell>
      </sui-table-row>
    </sui-table-body>
  </sui-table>
</template>

<script>
    export default {
      name: "BillingInfoRead",
      props: ["data"],
    }
</script>

<style scoped lang="less">
  .address {
    span {
      display: block;
      font-weight: normal;
    }
  }
</style>
